require('eonasdan-bootstrap-datetimepicker')


// WEBPACK FOOTER //
// ./src/plugins/datetimepicker.js